import { render, staticRenderFns } from "./SocialsTitle.vue?vue&type=template&id=4c7fa4f1&lang=pug&"
import script from "./SocialsTitle.vue?vue&type=script&lang=js&"
export * from "./SocialsTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports